import { ReactNode, createContext, useContext, useState } from 'react';
import { ERRORS } from '@/common/constants/errors';
import { ISignInResponse } from '@/common/integrations/menhir/employee/sessions/sessions.types';

interface IAuthenticationCredentials {
  email: string;
  password: string;
  authState?: ISignInResponse;
}

interface AuthenticationContextType extends IAuthenticationCredentials {
  setContextCredentials: (credentials: IAuthenticationCredentials) => void;
  resetContextCredentials: () => void;
}

const initialCredentials = {
  email: '',
  password: '',
  authState: undefined,
};

const AuthenticationContext = createContext<
  AuthenticationContextType | undefined
>(undefined);

export const AuthenticationProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [credentials, setCredentials] =
    useState<IAuthenticationCredentials>(initialCredentials);

  const resetCredentials = () => {
    setCredentials(initialCredentials);
  };
  return (
    <AuthenticationContext.Provider
      value={{
        ...credentials,
        setContextCredentials: setCredentials,
        resetContextCredentials: resetCredentials,
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};

export const useAuthenticationContext = () => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error(ERRORS.CONTEXT_VALUE_REQUIRED);
  }
  return context;
};
